export const GET_VACANCY = 'GET_VACANCY';
export const GET_DICTIONARY = 'GET_DICTIONARY';
export const POST_VACANCY = 'POST_VACANCY';
export const POST_FINDY_VACANCY = 'POST_FINDY_VACANCY';
export const POST_FILE = 'POST_FILE';
